module.exports = __webpack_public_path__ + "static/img/prq1.5827b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq1.jpg
// module id = /ji0
// module chunks = 2